import CampaignStatus from '@/Enums/CampaignManagement/CampaignStatus.enum';
import ItemStatus from '@/Enums/ItemStatus.enum';
import {
  ActiveStatusProps,
  ApprovalRequiredProps,
  CompletedStatusProps,
  DraftStatusProps,
  InactiveStatusProps,
} from '@/components/StatusChip/StatusProps';
import type { ChipProps } from '@mui/material';

export const itemStatusChipPropMap: Record<ItemStatus | CampaignStatus, ChipProps> = {
  [ItemStatus.ACTIVE]: ActiveStatusProps,
  [ItemStatus.INACTIVE]: InactiveStatusProps,
  [ItemStatus.COMPLETED]: CompletedStatusProps,
  [ItemStatus.DRAFT]: DraftStatusProps,
  [CampaignStatus.APPROVAL_REQUIRED]: ApprovalRequiredProps,
};

export const LINE_ITEM_STATUS_ORDER = {
  [ItemStatus.ACTIVE]: 0,
  [ItemStatus.COMPLETED]: 1,
  [ItemStatus.DRAFT]: 2,
  [ItemStatus.INACTIVE]: 3,
};
